import { IUntypedCommand, Topics } from '@zaplify/common';
export class SetProspectOwnerCommand extends IUntypedCommand {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly userId: string, readonly userOrganizationId: string, readonly prospectIds: string[]) {
        super();
    }
}
